// Real boutique photos — hosted locally to avoid third-party CDN references.
// Used in Hero (slideshow background) + Gallery (carousel).

export const BOUTIQUE_PHOTOS = [
    {
        src: '/photos/01-vitrine.png',
        label: 'Vitrine MANU VET',
        alt: "Vitrine boutique MANU VET — 37 av. Charles de Gaulle, Aulnay-sous-Bois (93600)",
    },
    {
        src: '/photos/02-boutique.png',
        label: 'Notre boutique',
        alt: "Boutique MANU VET — magasin de vêtements de travail et EPI à Aulnay-sous-Bois",
    },
    {
        src: '/photos/03-showroom.png',
        label: 'Showroom',
        alt: "Showroom MANU VET — exposition des marques EPI et vêtements pro",
    },
    {
        src: '/photos/04-lma.png',
        label: 'Espace LMA',
        alt: "Stand LMA Workwear chez MANU VET Aulnay",
    },
    {
        src: '/photos/05-blaklader.png',
        label: 'Rayon Blaklader',
        alt: "Rayon Blaklader Workwear — pantalons et vestes techniques MANU VET",
    },
    {
        src: '/photos/06-sols.png',
        label: "Sols & Blaklader",
        alt: "Espace Sol's et Blaklader — sweats, polos et workwear chez MANU VET",
    },
    {
        src: '/photos/07-chaussures.png',
        label: 'Chaussures de sécurité',
        alt: "Chaussures de sécurité Safety Jogger, U-Power, Parade — MANU VET Aulnay 93",
    },
    {
        src: '/photos/08-lafont.png',
        label: 'Espace Lafont',
        alt: "Stand Lafont — vêtements de travail français chez MANU VET",
    },
    {
        src: '/photos/09-pantalons.png',
        label: 'Pantalons techniques',
        alt: "Rayon pantalons techniques et workwear chez MANU VET",
    },
    {
        src: '/photos/10-hivis.png',
        label: 'Haute visibilité',
        alt: "Vêtements haute visibilité orange — MANU VET Aulnay 93600",
    },
    {
        src: '/photos/11-accessoires.png',
        label: 'Accessoires EPI',
        alt: "Accessoires EPI — lunettes et gants de protection MANU VET",
    },
];
